import React from "react";
import "./index.css";

const EmptyTimeslots = ({ handleClick }) => (
  <div className="empty-timeslots" onClick={handleClick}>
    + Add Timeslots
  </div>
);

export default EmptyTimeslots;
